<div class="stat_infos_header">
  <div class="select_camera_and_days">
    <form class="camera_select" [formGroup]="choiceDateForm" (ngSubmit)="onSubmit(false)">
      <div class="input_form">
        <mat-form-field appearance="outline" [color]="color">
          <mat-label>Select a camera</mat-label>
          <mat-select disableRipple formControlName="cameraId" (valueChange)="onSubmit(true)">
            <mat-option [value]="c.name" *ngFor="let c of camera">{{c.name}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>From</mat-label>
          <input matInput [max]="choiceDateForm.get('to').value" [matDatepicker]="from" formControlName="from">
          <mat-datepicker-toggle matSuffix [for]="from"></mat-datepicker-toggle>
          <mat-datepicker #from></mat-datepicker>
        </mat-form-field>
        <span>-</span>
        <mat-form-field appearance="outline">
          <mat-label>To</mat-label>
          <input matInput [max]="today" [matDatepicker]="to" formControlName="to">
          <mat-datepicker-toggle matSuffix [for]="to"></mat-datepicker-toggle>
          <mat-datepicker #to></mat-datepicker>
        </mat-form-field>
      </div>
      <button type="submit" [disabled]="choiceDateForm.invalid">
        <fa-icon [icon]="faSearch"></fa-icon>
      </button>
      <fa-icon [icon]="faFileExcel" class="faFileExcel" (click)="exportexcel()"></fa-icon>

    </form>
    <div class="days_select" *ngIf="loading">
      <mat-checkbox *ngFor="let d of daysSelected" [id]='d + "-cb"' [class]="d" [color]="color" [checked]="true"
        (change)="selectedOrNot(d)"> {{d}}
      </mat-checkbox>
    </div>
  </div>
</div>

<mat-spinner [diameter]="50" *ngIf="!loading "></mat-spinner>

<div class="charts" *ngIf="loading ">
  <app-chart *ngFor="let d of datas, let i = index" [day]="d?.label" [id]="d?.label" [data]="d?.data"
    [camera]="choiceDateForm.get('cameraId').value || camera[0].name" [dateStart]="choiceDateForm.get('from')?.value"
    [dateEnd]="choiceDateForm.get('to')?.value" [dateLabel]="sendDateTo(i)" [labelOrderly]="'% d\'occupation'"
    [typeChart]="'occupancyRate'" [@show]></app-chart>
</div>